export interface GoogleVoice {
  id: string;
  name: string;
  language: string;
  gender: 'male' | 'female' | 'neutral';
  category: 'standard' | 'neural' | 'wave-net' | 'studio' | 'chirp3-hd';
  description: string;
  sampleRate: number;
}

/**
 * Voci Google Text-to-Speech disponibili per l'italiano
 * Basato sulla documentazione ufficiale di Google Cloud TTS
 */
export const GOOGLE_VOICES: GoogleVoice[] = [
  // IT - Catalogo base + premium
  {
    id: 'it-IT-Standard-A',
    name: 'Alessandra',
    language: 'it-IT',
    gender: 'female',
    category: 'standard',
    description: 'Voce femminile italiana standard, chiara e professionale',
    sampleRate: 22050
  },
  {
    id: 'it-IT-Standard-B',
    name: 'Matilde',
    language: 'it-IT',
    gender: 'female',
    category: 'standard',
    description: 'Voce femminile italiana standard, neutra e leggibile',
    sampleRate: 22050
  },
  {
    id: 'it-IT-Standard-C',
    name: 'Marco',
    language: 'it-IT',
    gender: 'male',
    category: 'standard',
    description: 'Voce maschile italiana standard, autorevole e calda',
    sampleRate: 22050
  },
  {
    id: 'it-IT-Standard-D',
    name: 'Giulia',
    language: 'it-IT',
    gender: 'female',
    category: 'standard',
    description: 'Voce femminile italiana standard, giovane e dinamica',
    sampleRate: 22050
  },
  {
    id: 'it-IT-Standard-E',
    name: 'Davide',
    language: 'it-IT',
    gender: 'male',
    category: 'standard',
    description: 'Voce maschile italiana standard, bilanciata e versatile',
    sampleRate: 22050
  },
  {
    id: 'it-IT-Neural2-A',
    name: 'Sofia',
    language: 'it-IT',
    gender: 'female',
    category: 'neural',
    description: 'Voce femminile italiana neurale, molto naturale e espressiva',
    sampleRate: 24000
  },
  {
    id: 'it-IT-Neural2-C',
    name: 'Lorenzo',
    language: 'it-IT',
    gender: 'male',
    category: 'neural',
    description: 'Voce maschile italiana neurale, profonda e coinvolgente',
    sampleRate: 24000
  },
  {
    id: 'it-IT-Neural2-D',
    name: 'Chiara',
    language: 'it-IT',
    gender: 'female',
    category: 'neural',
    description: 'Voce femminile italiana neurale, dolce e accogliente',
    sampleRate: 24000
  },
  {
    id: 'it-IT-Neural2-F',
    name: 'Antonio',
    language: 'it-IT',
    gender: 'male',
    category: 'neural',
    description: 'Voce maschile italiana neurale, matura e saggia',
    sampleRate: 24000
  },
  {
    id: 'it-IT-Neural2-B',
    name: 'Riccardo',
    language: 'it-IT',
    gender: 'male',
    category: 'neural',
    description: 'Voce maschile italiana neurale, moderna e fluida',
    sampleRate: 24000
  },
  {
    id: 'it-IT-Wavenet-A',
    name: 'Elena',
    language: 'it-IT',
    gender: 'female',
    category: 'wave-net',
    description: 'Voce femminile italiana WaveNet, premium e realistica',
    sampleRate: 24000
  },
  {
    id: 'it-IT-Wavenet-B',
    name: 'Francesco',
    language: 'it-IT',
    gender: 'male',
    category: 'wave-net',
    description: 'Voce maschile italiana WaveNet, premium e autorevole',
    sampleRate: 24000
  },
  {
    id: 'it-IT-Wavenet-C',
    name: 'Valentina',
    language: 'it-IT',
    gender: 'female',
    category: 'wave-net',
    description: 'Voce femminile italiana WaveNet, premium e elegante',
    sampleRate: 24000
  },
  {
    id: 'it-IT-Wavenet-D',
    name: 'Alessandro',
    language: 'it-IT',
    gender: 'male',
    category: 'wave-net',
    description: 'Voce maschile italiana WaveNet, premium e professionale',
    sampleRate: 24000
  },

  // EN-US / EN-GB - voci premium per catalogo moderno multilingua
  {
    id: 'en-US-Neural2-F',
    name: 'Ava',
    language: 'en-US',
    gender: 'female',
    category: 'neural',
    description: 'English US Neural2, naturale e adatta a narrazioni moderne',
    sampleRate: 24000
  },
  {
    id: 'en-US-Neural2-J',
    name: 'Ethan',
    language: 'en-US',
    gender: 'male',
    category: 'neural',
    description: 'English US Neural2, tono caldo per storytelling premium',
    sampleRate: 24000
  },
  {
    id: 'en-US-Wavenet-F',
    name: 'Mia',
    language: 'en-US',
    gender: 'female',
    category: 'wave-net',
    description: 'English US WaveNet, alta qualità per esperienze immersive',
    sampleRate: 24000
  },
  {
    id: 'en-US-Wavenet-D',
    name: 'Noah',
    language: 'en-US',
    gender: 'male',
    category: 'wave-net',
    description: 'English US WaveNet, presenza vocale autorevole',
    sampleRate: 24000
  },
  {
    id: 'en-US-Studio-O',
    name: 'Olivia Studio',
    language: 'en-US',
    gender: 'female',
    category: 'studio',
    description: 'English US Studio, timbro broadcast moderno',
    sampleRate: 24000
  },
  {
    id: 'en-US-Studio-Q',
    name: 'Quentin Studio',
    language: 'en-US',
    gender: 'male',
    category: 'studio',
    description: 'English US Studio, qualità elevata per contenuti editoriali',
    sampleRate: 24000
  },
  {
    id: 'en-GB-Neural2-A',
    name: 'Emma',
    language: 'en-GB',
    gender: 'female',
    category: 'neural',
    description: 'English UK Neural2, elegante e naturale',
    sampleRate: 24000
  },
  {
    id: 'en-GB-Neural2-B',
    name: 'Oliver',
    language: 'en-GB',
    gender: 'male',
    category: 'neural',
    description: 'English UK Neural2, pulita e professionale',
    sampleRate: 24000
  },
  {
    id: 'en-GB-Studio-B',
    name: 'Charlotte Studio',
    language: 'en-GB',
    gender: 'female',
    category: 'studio',
    description: 'English UK Studio, voce premium per contenuti media',
    sampleRate: 24000
  },
  {
    id: 'en-GB-Chirp3-HD-Achernar',
    name: 'Achernar HD',
    language: 'en-GB',
    gender: 'neutral',
    category: 'chirp3-hd',
    description: 'English UK Chirp3-HD, ultra naturale per dialoghi moderni',
    sampleRate: 24000
  }
];

/**
 * Ottiene tutte le voci disponibili
 */
export function getAvailableVoices(): GoogleVoice[] {
  return GOOGLE_VOICES;
}

/**
 * Ottiene le voci filtrate per categoria
 */
export function getVoicesByCategory(category: 'standard' | 'neural' | 'wave-net' | 'studio' | 'chirp3-hd'): GoogleVoice[] {
  return GOOGLE_VOICES.filter(voice => voice.category === category);
}

/**
 * Ottiene le voci filtrate per genere
 */
export function getVoicesByGender(gender: 'male' | 'female' | 'neutral'): GoogleVoice[] {
  return GOOGLE_VOICES.filter(voice => voice.gender === gender);
}

/**
 * Ottiene una voce specifica per ID
 */
export function getVoiceById(id: string): GoogleVoice | undefined {
  return GOOGLE_VOICES.find(voice => voice.id === id);
}

/**
 * Ottiene le voci consigliate per i Genius Loci
 */
export function getRecommendedVoicesForGeniusLoci(): GoogleVoice[] {
  return [
    getVoiceById('it-IT-Neural2-A')!, // Sofia - femminile naturale
    getVoiceById('it-IT-Neural2-C')!, // Lorenzo - maschile profondo
    getVoiceById('it-IT-Wavenet-A')!, // Elena - femminile premium
    getVoiceById('it-IT-Wavenet-B')!, // Francesco - maschile premium
    getVoiceById('it-IT-Neural2-D')!, // Chiara - femminile dolce
    getVoiceById('it-IT-Neural2-F')!  // Antonio - maschile saggio
  ].filter(Boolean);
}

/**
 * Genera un prompt per la sintesi vocale con parametri personalizzati
 */
export function generateVoicePrompt(
  text: string,
  voiceId: string,
  options: {
    speed?: number; // 0.25 - 4.0
    pitch?: number; // -20.0 - 20.0
    volume?: number; // 0.0 - 96.0
  } = {}
): string {
  const voice = getVoiceById(voiceId);
  if (!voice) {
    throw new Error(`Voce non trovata: ${voiceId}`);
  }

  const { speed = 1.0, pitch = 0.0, volume = 0.0 } = options;

  return `
    <speak>
      <voice name="${voiceId}">
        <prosody rate="${speed}" pitch="${pitch}Hz" volume="${volume}dB">
          ${text}
        </prosody>
      </voice>
    </speak>
  `;
}
